import React from 'react';

const SNSLoginBtn = ({logo, text, login}) => {
    return (
        <>
            <button
                className={"btn cancel-btn-outline w-100 p-0"}
                onClick={login}
            >
                <img alt="logo" src={logo} className={"w-100 h-100"} />
                {/*{text}*/}
            </button>
        </>
    );
};

export default SNSLoginBtn;
